import "./PerfilUser.css";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../../Imagenes/logoMundo_shop.jpeg";
import { useState, useEffect, useCallback } from "react";

const API = process.env.REACT_APP_API_URL;

export default function PerfilUser() {
  const navigate = useNavigate();
  // Cargamos el usuario una sola vez al inicio
  const [user] = useState(() => JSON.parse(localStorage.getItem("user") || "null"));
  const [datos, setDatos] = useState(null);

  const renovarToken = async () => {
    console.log("Intentando renovar sesión...");
    try {
      const res = await fetch(`${API}/user/refresh`, {
        method: "POST",
        credentials: "include" 
      });

      if (res.ok) {
        const data = await res.json();
        // Guardamos el nuevo token en el storage
        localStorage.setItem("token", data.accessToken);
        console.log("Token renovado con éxito");
        return true;
      }
    } catch (error) {
      console.error("Error crítico al renovar token:", error);
    }
    return false;
  };
const traerDatos = useCallback(async () => {
    if (!user?.id) return;

    // Función interna para hacer el fetch y poder reintentarlo fácilmente
    const ejecutarPeticion = async (token) => {
      return await fetch(`${API}/user/traerUserId/${user.id}`, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
    };

    try {
      // 1. Primer intento con el token que tengamos
      let tokenActual = localStorage.getItem("token");
      let response = await ejecutarPeticion(tokenActual);

      // 2. Si el servidor dice que caducó (403)
      if (response.status === 403) {
        console.log("Token caducado. Usando Refresh Token...");
        
        const renovado = await renovarToken(); // Esta función guarda el nuevo token en localStorage
        
        if (renovado) {
          // 3. REINTENTO: Pillamos el token RECIÉN GUARDADO
          const nuevoToken = localStorage.getItem("token");
          console.log("Reintentando con el nuevo token:", nuevoToken?.slice(-5));
          
          response = await ejecutarPeticion(nuevoToken);
        } else {
          handleLogout();
          return;
        }
      }

      if (!response.ok) throw new Error("Error tras reintento");
      
      const data = await response.json();
      if (data?.datos) setDatos(data.datos);

    } catch (error) {
      console.error("Error en el flujo de datos:", error);
    }
  }, [user?.id, API]);

  useEffect(() => {
    traerDatos();
  }, [traerDatos]);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/login");
  };

  if (!user) {
    return (
      <div className="perfil-wrapper">
        <div className="perfil-card unauthorized">
          <h2>No has iniciado sesión</h2>
          <NavLink to="/login" className="btn-primary">Ir al Login</NavLink>
        </div>
      </div>
    );
  }

  return (
    <div className="perfil-wrapper">
      <div className="perfil-container">
        <div className="perfil-nav-top">
          <NavLink to="/" className="back-link">← Volver a la tienda</NavLink>
        </div>

        <div className="perfil-main">
          <div className="perfil-sidebar">
            <div className="avatar-section">
              <div className="avatar-circle">
                {datos?.nombre?.charAt(0).toUpperCase() || "U"}
              </div>
              <h3>{datos?.nombre || "Cargando..."}</h3>
              <p className="user-role">{user.rol?.replace("ROLE_", "")}</p>
            </div>
            <img src={logo} alt="Mundo Shop" className="perfil-logo-bg" />
          </div>

          <div className="perfil-content">
            <h2 className="content-title">Mi Cuenta</h2>
            <div className="perfil-menu-grid">
              <NavLink to="/ClientePedidos" className="menu-item">
                <div className="menu-icon">📦</div>
                <div className="menu-text">
                  <span>Mis pedidos</span>
                  <small>Rastrea y revisa tus compras</small>
                </div>
              </NavLink>
              <NavLink to="/PerfilUser/Editar" className="menu-item">
                <div className="menu-icon">⚙️</div>
                <div className="menu-text"><span>Ajustes</span><small>Actualiza tu info</small></div>
              </NavLink>
              <button className="menu-item logout" onClick={handleLogout}>
                <div className="menu-icon">🚪</div>
                <div className="menu-text"><span>Cerrar sesión</span></div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}